<template>
  <section v-show="active" class="app-modal__section">
    <header class="app-modal__section-head">
      <h4>{{ text.heading.title }}</h4>
      <p>{{ text.heading.description }}</p>
    </header>

    <div class="app-modal__grid two-columns">
      <div class="app-modal-field full-width">
        <span>{{ text.fields.area }}</span>
        <multiselect
          v-model="form.area"
          :options="options.areas"
          track-by="value"
          label="label"
          :show-labels="false"
          :searchable="true"
          :allow-empty="true"
          :disabled="disabled"
          class="app-modal-select"
          :placeholder="text.fields.areaPlaceholder"
        >
          <template #noResult><span>{{ commonText.noOption }}</span></template>
          <template #noOptions><span>{{ commonText.noOption }}</span></template>
        </multiselect>
      </div>

      <label class="app-modal-field full-width">
        <span>{{ text.fields.comments }}</span>
        <textarea
          v-model.trim="form.comments"
          class="form-control app-modal-field__textarea"
          :disabled="disabled"
          rows="4"
          :placeholder="text.placeholders.comments"
        ></textarea>
      </label>
    </div>
  </section>
</template>

<script>
import { PAYMENTS_TEXT } from '@/texts/catalog/payments';

const DETAILS_TEXT = PAYMENTS_TEXT.planModal.details;
const COMMON_TEXT = PAYMENTS_TEXT.planModal.common;

export default {
  name: 'PaymentPlanModalSectionDetails',
  data() {
    return {
      text: DETAILS_TEXT,
      commonText: COMMON_TEXT,
    };
  },
  props: {
    active: {
      type: Boolean,
      default: false,
    },
    form: {
      type: Object,
      required: true,
    },
    options: {
      type: Object,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
